import React from "react";
import StateTaxOregonView from "./StateTaxOregonView";

export default function StateTaxSpringfieldView(props) {
  return <StateTaxOregonView {...props} />;
}
